import { io } from 'socket.io-client'

// Derive socket URL from API URL (strip /api suffix) or fall back to current origin
const API_URL = import.meta.env.VITE_API_URL || ''
const SOCKET_URL = API_URL 
  ? API_URL.replace(/\/api\/?$/, '') 
  : (import.meta.env.VITE_SOCKET_URL || window.location.origin)

class SocketService {
  constructor() {
    this.socket = null
  }

  connect(userId) {
    if (!this.socket) {
      try {
        const token = localStorage.getItem('token')
        this.socket = io(SOCKET_URL, {
          transports: ['websocket', 'polling'],
          withCredentials: true,
          auth: {
            token: token
          },
          reconnection: true,
          reconnectionDelay: 1000,
          reconnectionDelayMax: 5000,
          reconnectionAttempts: 5,
          timeout: 10000,
          autoConnect: true
        })
        
        this.socket.on('connect', () => {
          if (userId) {
            this.socket.emit('join_room', `user_${userId}`)
          }
        })

        this.socket.on('disconnect', () => {
          // Disconnected
        })

        this.socket.on('connect_error', () => {
          // Socket.io is an optional real-time enhancement
        })
      } catch (err) {
        // Graceful fallback
      }
    }
    
    return this.socket
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect()
      this.socket = null
    }
  }

  on(event, callback) {
    if (this.socket) {
      this.socket.on(event, callback)
    }
  }

  off(event, callback) {
    if (this.socket) {
      this.socket.off(event, callback)
    }
  }

  emit(event, data) {
    if (this.socket) {
      this.socket.emit(event, data)
    }
  }
}

export default new SocketService()
